import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRemoveInstagramIntegrationMutation = createMutationHook(
  ShopRendererApiClient.removeInstagramIntegrationV2,
  {
    mutationKey: ['removeInstagramIntegration'],
  },
)
